<template>
  <Layout :isLoading="isLoading">
    <div class="bloco">
      <HeaderPage
        :page-titles="pageTitles"
        :form-open="form"
        @onClick="formOpen"
      />
      <div v-if="form">
        <b-input-group prepend="Conveniado" class="mt-3 mb-4">
          <b-form-input
            @focus="showConveniadoFilter = true"
            name="filterConveniado"
            v-model="filterConveniadoText"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="handleGet">Pesquisar</b-button>
          </b-input-group-append>
          <div class="filtered-select" v-if="showConveniadoFilter">
            <ul>
              <li
                v-for="conveniado of filteredConveniados"
                :key="conveniado._id"
                @click="selectConveniado(conveniado)"
                >{{ conveniado.nome }}</li
              >
            </ul>
          </div>
        </b-input-group>
        <div class="row ml-1">
          <div class="mr-3 w40">
            <label for="example-datepicker">Data Inicial</label>
            <b-form-datepicker
              id="example-datepicker"
              v-model="data_inicial"
              class="mb-2"
              :disabled="!cliente._id"
            >
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </div>
          <div>
            <label for="example-datepicker1">Data Final</label>
            <b-form-datepicker
              id="example-datepicker1"
              v-model="data_final"
              class="mb-2"
              :disabled="!cliente._id"
            >
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </div>
        </div>

        <div>
          <p>Nome: {{ cliente.loja }}</p>
        </div>
        <div>
          <b-table
            striped
            hover
            :items="itens"
            :fields="itensfields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2" v-if="!(usuario.tipo=='verificador')">
                <button
                  v-if="row.item.status !== 'Pago'"
                  v-b-tooltip.hover
                  title="Confirmar"
                  type="button"
                  class="btn btn-light"
                  @click="confirmModal(row.item)"
                >
                  <i class="uil uil-check"></i>
                </button>
              </div>
            </template>
            <template v-slot:cell(data)="row">
              {{ formatDate(row.item.data) }}
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>
      </div>
      <section v-else>
        <pagamentoConveniado
          :pagamento="pagamento"
          :onEdit="handleEdit"
          :onSubmit="handleCreate"
        ></pagamentoConveniado>
      </section>
      <b-modal
        id="confirmar-pagamento"
        centered
        title="Confirmar Pagamento"
        hide-footer
      >
        <div class="d-flex flex-column">
          <b-form-group label="Procedimento">
            <b-form-input
              v-if="pagamento.procedimento"
              v-model="pagamento.procedimento.descricao"
              locale="pt-Br"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Data">
            <b-form-datepicker
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              v-model="pagamento.data"
              disabled
              locale="pt-Br"
            >
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
          <b-form-group label="Valor">
            <b-form-input
              type="text"
              v-model="pagamento.valor"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Comprovante de Pagamento">
            <b-form-input
              id="exampleInput6"
              v-model="pagamento.comprovante"
              v-mask="'#########.##'"
              class="edit-input"
              type="text"
              required
              placeholder="123123456-21"
            />
          </b-form-group>
          <b-form-group label="Forma de Pagamento">
            <b-form-select
              v-model="pagamento.forma_pagamento"
              :options="formPgtOption"
              class="edit-input"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Status">
            <b-form-select
              v-model="pagamento.status"
              :options="statusOption"
              class="edit-input"
            >
            </b-form-select>
          </b-form-group>
        </div>
        <div class="d-flex">
          <b-button class="mr-3 mt-3" block @click="validForm"
            >Confirmar</b-button
          >
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import Table from '../../../../components/tables/table-register.vue'
import PagamentoConveniado from '../../../../components/forms/financeiro/pagamentoConveniado-form.vue'
import Pagamentos from '@/src/services/pagamento'
import alertMixin from '@/src/mixins/alertMixin'
import conveniadoMixin from '@/src/mixins/conveniadoMixin'
import moment from 'moment'

export default {
  components: {
    Layout,
    HeaderPage,
    Table,
    pagamentoConveniado: PagamentoConveniado,
  },
  mixins: [alertMixin, conveniadoMixin],
  data() {
    return {
      pageTitles: {
        title: 'Pagamento Dos Conveniados',
        subtitle: 'Pagamento Conveniados',
      },
      form: true,
      itens: [],
      itensfields: [
        { key: 'actions', label: '' },
        { key: 'procedimento[0].descricao', label: 'Procedimento' },
        { key: 'data', label: 'Data' },
        { key: 'valor', label: 'Valor' },
        { key: 'status', label: 'Status' },
        { key: 'forma_pagamento', label: 'Pagamento' },
        { key: 'comprovante', label: 'Comprovante' },
      ],
      statusOption: [
        { value: 'Aberto', text: 'Aberto' },
        { value: 'Pago', text: 'Pago' },
        { value: 'Fechado', text: 'Fechado' },
      ],
      formPgtOption: [
        { value: 'Dinheiro', text: 'Dinheiro' },
        { value: 'Pix', text: 'Pix' },
      ],
      cliente: {},
      pagamento: {},
      confirmPagamento: {},
      filter: '',
      data_inicial: '',
      data_final: '',
      isLoading: false,
      showConveniadoFilter: false,
      filterConveniadoText: '',
      filteredConveniados: [],
      conveniados: [],
      currentPage: 1,
      perPage: 5,
      usuario: this.$store.state.auth.currentUser.usuario,
    }
  },
  watch: {
    filterConveniadoText() {
      this.filterConveniado(this.filterConveniadoText)
      this.showConveniadoFilter = true
      this.showFormConveniadoFilter = true
    },
  },
  computed: {
    rows() {
      return this.itens.length
    },
  },
  mounted() {
    this.handleGet()
    this.loadAllAttributes()
  },
  methods: {
    formatDate(date) {
      if (date) return moment(date).format('DD/MM/YYYY')
    },
    confirmModal(pagamento) {
      this.pagamento = pagamento
      this.$bvModal.show('confirmar-pagamento')
    },
    validForm() {
      this.pagamento.status = 'Pago'
      this.handleEdit()
    },
    loadAllAttributes() {
      this.loadConveniadosBySelect().then((conveniados) => {
        this.conveniados = conveniados
        this.filterConveniado()
      })
    },
    selectConveniado(conveniadoId) {
      this.findOneConveniado(conveniadoId._id).then((response) => {
        let conveniado = response.data
        this.cliente = conveniado
        this.filterConveniadoText = conveniado.nome
        this.filter = conveniado._id
        setTimeout(() => {
          this.showConveniadoFilter = false
          this.showFormConveniadoFilter = false
        }, 100)
      })
    },
    filterConveniado(filter) {
      if (!filter) {
        this.filteredConveniados = this.conveniados.slice(0, 4)
        return
      }

      this.filteredConveniados = this.conveniados
        .filter(
          (i) =>
            i.nome.toLowerCase().includes(filter.toLowerCase()) ||
            (i.registro ? i.registro.toLowerCase() : '').includes(
              filter.toLowerCase()
            )
        )
        .slice(0, 5)
    },
    handleGet() {
      console.log('aqui')
      console.log(this.filter)
      this.isLoading = true
      Pagamentos.list(
        'conveniado',
        this.filter,
        this.data_inicial,
        this.data_final
      )
        .then((response) => {
          this.itens = response.data.pagamentos
          this.cliente = response.data.responsavel
            ? response.data.responsavel
            : {}
        })
        .catch((error) => {
          this.errorMessage(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleCreate() {
      this.isLoading = true
      this.pagamento['tipo'] = 'conveniado'
      Pagamentos.create(this.pagamento)
        .then(() => {
          this.pagamento = {}
          this.successMessage('Pagamento Criado com sucesso')
        })
        .catch((error) => {
          this.errorMessage(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleEdit() {
      this.isLoading = true
      Pagamentos.update(this.pagamento._id, this.pagamento)
        .then(() => {
          this.pagamento = {}
          this.form = true
          this.$bvModal.hide('confirmar-pagamento')
          this.successMessage('Pagamento Editado com sucesso')
        })
        .catch((error) => {
          this.errorMessage(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    modalEdit(item) {
      this.pagamento = item
      this.formOpen()
    },
    onDelete(id) {
      try {
        this.clientes = []
        Pagamentos.remove(id).then(() => {
          this.handleGet()
          this.successMessage('Pagamento Deletado com sucesso')
        })
      } catch (error) {
        this.errorMessage(error)
      }
    },
    formOpen() {
      if (this.form === false) {
        this.pagamento = {}
        this.form = true
      } else {
        this.handleGet()
        this.form = false
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss" scoped></style>
<style scoped>
.filtered-select {
  position: absolute;
  background-color: white;
  width: 96%;
  left: 80px;
  z-index: 20;
  top: 40px;
}
.filtered-select ul {
  list-style: none;
  padding-left: 19px;
}
.filtered-select ul li {
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}
.filtered-select ul li:hover {
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
</style>

